<template>
  <div class="form-centered-container">
    <div class="form-container" v-show="!recoverPassword">
      <form class="login" v-on:submit.prevent="login()" ref="loginForm">
        <h1>Ingresar</h1>
        <div class="form-row">
          <div class="col-md-12">
            <p for="userEmail">Correo electrónico</p>
            <input required v-model="user.username" type="email" class="form-control" id="userEmail" aria-describedby="emailHelp" placeholder="crbox@hotmail.com">
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-12">
            <p for="userPassword">Contraseña</p>
            <input required v-model="user.password" type="password" class="form-control" id="userPassword" aria-describedby="emailHelp" placeholder="xxxxxxxxxxxx">
          </div>
        </div>
        <div class="form-group form-check">
          <input v-model="rememberMe" type="checkbox" class="form-check-input" id="exampleCheck1">
          <label class="form-check-label" for="exampleCheck1">Remember Me</label>
        </div>
        <button>Ingresar</button>
        <div class="flex-row login-links">
          <a class="green" @click="recoverPassword = true">Olvide mi contraseña</a>
          <a href="/register">Afíliese</a>
        </div>
      </form>
    </div>
    <splash :recoverPassword="recoverPassword" @changedSuccesfully="recoverPassword = $event"></splash>
 </div>
</template>

<script>
import queryString from 'query-string'
import Splash from './components/splash.vue'
/* eslint-disable */
export default {
  context: 'login context',
  name: 'Login',
  data: () => {
    return { 
      user: {
        username: "", 
        password: "",
      },
      recoverPassword: false,
      rememberMe: false 
    }
  },
  components: {
    Splash
  },
  mounted () {
    if(this.$auth.check()){
      this.$router.push('/dashboard')
    }
  },
  methods: {
    login: function () {
      let loader = this.$loading.show({
        container: this.$refs.loginForm
      });
      this.$auth.login({
            data: queryString.stringify({
              grant_type: "password",
              username: this.user.username,
              password: this.user.password
            }),
            rememberMe: this.rememberMe,
            success: function (res) {
              this.$auth.user({email: this.user.username})
              this.$cookie.set("user",this.user.username,1)
              loader.hide();
            }
        })
        .then(() => {       
          }, (res) => {
              let message = "Ocurrió un error"
              if(res.message == "Network Error"){
                message = "Servicio no disponible"
              }else if(res.response.data.error_description == "The user name or password is incorrect."){
                message = "El usuario o la contraseña es incorrecta"
              }
              this.$notify({
                group: 'notifications',
                type: 'error',
                title: 'Login',
                text: message,
                duration: 4000,
                speed: 1000
              });             
              loader.hide();
        });
    }
  }
}
</script>

